import { Box, Text } from "@chakra-ui/react";
import Tooltip from "@components/Tooltip";

const AirdropVaultTooltip = () => {
  return (
    <Tooltip
      placement="top"
      label={
        <Box>
          <Text>Additional Airdrops - Kernel Points, Infra Points</Text>
          {/* <Text>Estimated Airdrop rewards - 2.32%</Text> */}
          {/* <Text>Additional Airdrops - Kelp Miles, Infra Points</Text> */}
          <Text fontWeight="400">
            Check <strong>&apos;APR Reports&apos;</strong> for details
          </Text>
        </Box>
      }
    />
  );
};

export default AirdropVaultTooltip;
